import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Hero from "./components/Home/Hero/Hero";
import Price from "./components/Price/Price";
import SignUp from "./components/Signup/SignUp";
import OutStore from "./components/OutStore/OutStore";
import Comming from "./Comming";
import ContactUs from "./components/Support/ContactUs";
import MusicPublishing from "./components/Services/MusicPublishing/MusicPublishing";
import Services from "./components/Services/Services";
import RightsManagement from "./components/Services/RightsManagement/RightsManagement";
import YoutubeMonetisation from "./components/Services/YoutubeMonetisation/YoutubeMonetisation";
import DigitalDistribution from "./components/Services/DigitalDistribution/DigitalDistribution";
import YoutubePromotion from "./components/YoutubePromotion/YoutubePromotion";
import About from "./components/About/About";
import SellMusic from "./components/SellMusic/SellMusic";
import MusicDistribution from "./components/MusicDistribution/MusicDistribution";
import TNC from "./components/TncPrivacyPolicy/TNC";
import PrivacyPolicy from "./components/TncPrivacyPolicy/PrivacyPolicy";
import { useEffect } from "react";
import ScrollToTopButton from "./ScrollToTop";
import MetaRoute from "./MetaRoute";
import YoutubeContentId from "./components/Services/YoutubeContentId/YoutubeContentId";
// import Navbar from "./agent-dashboard/Common/AgentNavbar";
import Footers from "./components/common/Footers/Footer";
import Footer from "./agent-dashboard/Common/Footer";
import Navbars from "./components/common/navbar/Navbars";
import AgentNavbars from "./agent-dashboard/Common/AgentNavbars";
import Dashboard from "./agent-dashboard/Dashboard/Dashboard";
import Releases from "./agent-dashboard/Support/Releases";
import CreateRelease from "./agent-dashboard/Distribution/CreateRelease";
import IncompleteReleases from "./agent-dashboard/Distribution/IncompleteReleases";
import Payouts from "./agent-dashboard/Payouts/Payouts";
import Overview from "./agent-dashboard/Reports/Overview";
import SignIn from "./components/Signup/SignIn";
import Profile from "./agent-dashboard/Profile/Profile";
import ProtectedRoute from "./ProtectedRoute";
import EditRelease from "./agent-dashboard/Distribution/EditRelease";
import AlbumDetailPage from "./agent-dashboard/AlbumDetailPage";
import Profile2, { InvoiceTemplate } from "./agent-dashboard/Profile/Profile2";
import Payments from "./components/Payments/Payments";
import PaymentForm from "./PaymentForm";
import Plans from "./agent-dashboard/Dashboard/Plans";
import Checkout from "./agent-dashboard/Dashboard/Checkout";
import ThankYouPage from "./components/Signup/ThankYouPage";
import PaymentSuccess from "./PaymentSuccess";
import AddArtist from "./agent-dashboard/Profile/AddArtist";
import AllTickets from "./agent-dashboard/Query/AllTickets";
import TicketChat from "./agent-dashboard/Query/TicketChat";
import RaiseTicket from "./agent-dashboard/Query/RaiseTicket";
import BestMusicDistribution from "./components/MusicDistribution/BestMusicDistribution";
import Faq from "./components/Faqs/Faq";
import Career from "./components/Career/Career";
import SpotifyForArtists from "./components/SpotifyForArtists/SpotifyForArtists";
import ContentPolicy from "./components/TncPrivacyPolicy/ContentPolicy";
import CookiePolicy from "./components/TncPrivacyPolicy/CookiePolicy";
import DistributeAppleMusic from "./components/SpotifyForArtists/DistributeAppleMusic";
import GetMusicOnJioSaavn from "./components/SpotifyForArtists/GetMusicOnJioSaavn";
import TikTokForArtists from "./components/SpotifyForArtists/TikTokForArtists";
import DeezerForArtists from "./components/SpotifyForArtists/DeezerForArtists";
import GetMusicOnBoomplay from "./components/SpotifyForArtists/GetMusicOnBoomplay";
import AnghamiForArtists from "./components/SpotifyForArtists/AnghamiForArtists";
import AmazonMusicForArtists from "./components/SpotifyForArtists/AmazonMusicForArtists";
import GooglePlayMusicForArtists from "./components/SpotifyForArtists/GooglePlayMusicForArtists";
import GetMusicOn7Digital from "./components/SpotifyForArtists/GetMusicOn7Digital";
import GetMusicOnAWA from "./components/SpotifyForArtists/GetMusicOnAWA";
import GetMusicOnBeatport from "./components/SpotifyForArtists/GetMusicOnBeatport";
import GetMusicOnBeatsource from "./components/SpotifyForArtists/GetMusicOnBeatsource";
import GetMusicOnTidal from "./components/SpotifyForArtists/GetMusicOnTidal";
import GetMusicOnFacebook from "./components/SpotifyForArtists/GetMusicOnFacebook";
import GetMusicOnYoutube from "./components/SpotifyForArtists/GetMusicOnYoutube";
import GetMusicOnBeep from "./components/SpotifyForArtists/GetMusicOnBeep";
import GetMusicOnBMAT from "./components/SpotifyForArtists/GetMusicOnBMAT";
import GetMusicOnGracenote from "./components/SpotifyForArtists/GetMusicOnGracenote";
import GetMusicOnFizy from "./components/SpotifyForArtists/GetMusicOnFizy";
import GetMusicOnTencent from "./components/SpotifyForArtists/GetMusicOnTencent";
import GetMusicOnHungama from "./components/SpotifyForArtists/GetMusicOnHungama";
import GetMusicOnVevo from "./components/SpotifyForArtists/GetMusicOnVevo";
import GetMusicOnSoundCloud from "./components/SpotifyForArtists/GetMusicOnSoundCloud";
import GetMusicOnHuawei from "./components/SpotifyForArtists/GetMusicOnHuawei";
import GetMusicOnLenovo from "./components/SpotifyForArtists/GetMusicOnLenovo";
import GetMusicOnGionee from "./components/SpotifyForArtists/GetMusicOnGionee";
import GetMusicOnRaaga from "./components/SpotifyForArtists/GetMusicOnRaaga";
import GetMusicOnYouTubeMusic from "./components/SpotifyForArtists/GetMusicOnYouTubeMusic";
import GetMusicOnOnkyo from "./components/SpotifyForArtists/GetMusicOnOnkyo";
import GetMusicOnKKBOX from "./components/SpotifyForArtists/GetMusicOnKKBOX";
import GetMusicOnLineMusic from "./components/SpotifyForArtists/GetMusicOnLineMusic";
import GetMusicOnYandex from "./components/SpotifyForArtists/GetMusicOnYandex";
import RefundPolicy from "./components/Support/RefundPolicy/RefundPolicy";
import ArtistAgreement from "./components/ArtistAgreement/ArtistAgreement";
import LabelAgreement from "./components/LabelAgreement/LabelAgreement";
import ContactFloat from "./components/ContactFloat/ContactFloat";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const location = useLocation();
  const isArtistRoute = location.pathname.includes("/artist/");

  function Navbarr() {
    const location = useLocation();
    // const isAgentRegistration = location.pathname === "/agent-registration";
    const isArtistRoute = location.pathname.includes("/artist/");
    // !location.pathname.startsWith("/agent/login");

    if (
      location.pathname === "/signup" ||
      location.pathname === "/signin" ||
      // location.pathname === "/thank-you" ||
      location.pathname === "/artist/plans"
    ) {
      return null; // Return null to hide the footer
    }
    return isArtistRoute ? <AgentNavbars /> : <Navbars />;
  }

  function Footerr() {
    const location = useLocation();
    // const isDashboard = location.pathname === "/agent/dashboard";
    // const isAgentRegistration = location.pathname === "/agent-registration";
    const isArtistRoute = location.pathname.includes("/artist/");

    if (
      location.pathname === "/signup" ||
      location.pathname === "/signin"
      // || location.pathname === "/thank-you"
    ) {
      return null; // Return null to hide the footer
    }
    return isArtistRoute ? (
      // <Footer />
      ""
    ) : (
      <Footers />
    );

    // return <Footer />;
  }

  return (
    <div className="App" style={{ background: "#000" }}>
      <Navbarr />
      <Routes>
        <Route
          path="/"
          element={
            <MetaRoute
              title="Best Music Distribution Company in India | FT Tunes"
              description="Looking for the best music distribution company in India? FT Tunes helps independent artists distribute music to Spotify, Apple Music, YouTube, JioSaavn and 150+ platforms with fast approval and affordable pricing."
            >
              <Hero />
            </MetaRoute>
          }
        />
        <Route
          path="/music-distribution-pricing"
          element={
            <MetaRoute
              title="Affordable Music Distribution Pricing & Services | FT Tunes"
              description="Discover FT Tunes for competitive music distribution prices. Our expert music distribution services ensure your tracks reach global audiences affordably."
            >
              <Price />
            </MetaRoute>
          }
        />
        <Route
          // path="/signup"
          element={
            <MetaRoute
              title="Sign Up with FT Tunes for Worldwide Music Distribution Services | FT Tunes"
              description="Sign up with FT Tunes for top-tier music distribution and global music distribution services and get your music heard worldwide."
            >
              <SignUp />
            </MetaRoute>
          }
        />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route
          path="/payment-success/:paymentId"
          element={<PaymentSuccess />}
        />
        <Route
          path="/signin"
          element={
            <MetaRoute
              title="Sign In with FT Tunes for Worldwide Music Distribution Services | FT Tunes"
              description="Sign in with FT Tunes for top-tier music distribution and global music distribution services and get your music heard worldwide."
            >
              <SignIn />
            </MetaRoute>
          }
        />
        <Route
          path="/about"
          element={
            <MetaRoute
              title="Leading Music Distribution Company in India | FT Tunes"
              description="FT Tunes is a leading music distribution company in India, offering top-notch music distribution services to elevate your sound to global audiences."
            >
              <About />
            </MetaRoute>
          }
        />
        <Route
          path="/music-stores"
          element={
            <MetaRoute
              title="Trusted Music Distribution Partners | FT Tunes"
              description="Your trusted music distribution partner for YouTube, Wynk Music, Gaana, Amazon Music, Apple Music and more. Reach global audiences with ease."
            >
              <OutStore />
            </MetaRoute>
          }
        />
        <Route
          path="/music-distribution-services"
          element={
            <MetaRoute
              title="Best Music Distribution Services in India | FT Tunes"
              description="FT Tunes offers the best music distribution services in India. Our digital music distribution solutions ensure your tracks reach a global audience seamlessly."
            >
              <Services />
            </MetaRoute>
          }
        />
        <Route
          path="/sell-your-music"
          element={
            <MetaRoute
              title="Sell Your Music Globally Online | 1K+ Music Sold | FT Tunes"
              description="Sell your music globally online with FT Tunes. A trusted platform with 1K+ music sold, offering fast, simple and worldwide music distribution for every artist."
            >
              <SellMusic />
            </MetaRoute>
          }
        />
        <Route
          path="/music-distribution"
          element={
            <MetaRoute
              title="Top Music Distribution Solutions| Trusted by 1K+ Clients"
              description="FT Tunes provides top music distribution services and solutions in India, trusted by 1K+ clients for fast releases, global reach and seamless artist support."
            >
              <MusicDistribution />
            </MetaRoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <MetaRoute
              title="Contact FT Tunes: Leading Music Distribution Company | Digital & Global Music Distribution Services"
              description="Contact FT Tunes, your trusted music distribution company, for top-notch digital and global music distribution services. Reach out for seamless distribution."
            >
              <ContactUs />
            </MetaRoute>
          }
        />
        <Route
          path="/music-right-management"
          element={
            <MetaRoute
              title="Best Music Rights Management Services in India | 1K+ Clients"
              description="FT Tunes offers the best music rights management services in India, preferred by 1K+ clients for secure, reliable and hassle-free rights protection."
            >
              <RightsManagement />
            </MetaRoute>
          }
        />
        <Route
          path="/music-publishing"
          element={
            <MetaRoute
              title="Global Music Distribution Services India | 1K+ Music Distributed"
              description="FT Tunes delivers the best global music distribution services in India, with 1K+ music distributed, ensuring fast releases and worldwide reach for every artist."
            >
              <MusicPublishing />
            </MetaRoute>
          }
        />
        <Route
          path="/youtube-monetization"
          element={
            <MetaRoute
              title="YouTube Monetization Services India |Trusted by 1K+ Clients"
              description="FT Tunes provides the best YouTube monetization services in India, trusted by 1K+ clients for fast approval, secure earnings & complete channel growth support."
            >
              <YoutubeMonetisation />
            </MetaRoute>
          }
        />
        <Route
          path="/youtube-promotion"
          element={
            <MetaRoute
              title="YouTube Promotion | FT Tunes"
              description="Get YouTube working for your music. We use data-driven YouTube promotion to help artists grow faster."
            >
              <YoutubePromotion />
            </MetaRoute>
          }
        />
        <Route
          path="/digital-distribution"
          element={
            <MetaRoute
              title="Global Music Distribution Services India | 1K+ Music Distributed"
              description="FT Tunes delivers the best global music distribution services in India, with 1K+ music distributed, ensuring fast releases and worldwide reach for every artist."
            >
              <DigitalDistribution />
            </MetaRoute>
          }
        />

        <Route
          path="/best-music-distribution-india"
          element={
            <MetaRoute
              title=""
              description=""
            >
              <BestMusicDistribution />
            </MetaRoute>
          }
        />

        <Route
          path="/terms-of-service"
          element={
            <MetaRoute
              title="FT Tunes Terms and Conditions | Music Distribution Solutions"
              description="FT Tunes terms and conditions detail the use of our worldwide music distribution services for a seamless experience."
            >
              <TNC />
            </MetaRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <MetaRoute
              title="FT Tunes Privacy Policy | Global Music Distribution Company & Music Distribution Partners"
              description="FT Tunes privacy policy outlines how we protect your data as a global music distribution company and trusted music distribution partners."
            >
              <PrivacyPolicy />
            </MetaRoute>
          }
        />
        <Route
          path="/youtube-content-id"
          element={
            <MetaRoute
              title="Premier YouTube Content ID Services | Expert Management and Monetization for YouTube Content ID"
              description="FT Tunes offers expert YouTube Content ID management services, ensuring your music rights are protected. Trust us for seamless YouTube content ID management."
            >
              <YoutubeContentId />
            </MetaRoute>
          }
        />
        <Route
          path="/payonline"
          element={
            <MetaRoute
              title="Pay Online | Music Distribution & Promotion | FT Tunes"
              description="Pay online securely with FT Tunes, a trusted music distribution and promotion company offering fast payments, smooth services and complete support for artists."
            >
            <Payments />
           </MetaRoute>
          }
        />
        {/* <Route
          path="/comming-soon"
          element={
            <MetaRoute
              title="Coming Soon | FT Tunes"
              description="Stay tuned for exciting new services and features coming soon to FT Tunes, your trusted music distribution partner."
            >
              <Comming />
            </MetaRoute>
          }
        /> */}
        {/* <Route path="/artist/test" element={<AgentNavbars />} /> */}
        <Route
          path="/artist/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/releases"
          element={
            <ProtectedRoute>
              <Releases />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/releases/create"
          element={
            <ProtectedRoute>
              <CreateRelease />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/releases/edit/:id"
          element={
            <ProtectedRoute>
              <EditRelease />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/incomplete-releases"
          element={
            <ProtectedRoute>
              <IncompleteReleases />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/payouts"
          element={
            <ProtectedRoute>
              <Payouts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/reports"
          element={
            <ProtectedRoute>
              <Overview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/profile"
          element={
            <ProtectedRoute>
              <Profile2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/album/:id"
          element={
            <ProtectedRoute>
              <AlbumDetailPage />
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/test"
          element={
            // <ProtectedRoute>
            <PaymentForm />
            // </ProtectedRoute>
          }
        /> */}

        <Route
          path="/artist/plans"
          element={
            <ProtectedRoute>
              <Plans />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/cart/:plan"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/artist/add-artist-under-label"
          element={
            <ProtectedRoute>
              <AddArtist />
            </ProtectedRoute>
          }
        />

        <Route
          path="/artist/tickets"
          element={
            <ProtectedRoute>
              <AllTickets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/tickets/:ticketId"
          element={
            <ProtectedRoute>
              <TicketChat />
            </ProtectedRoute>
          }
        />
        <Route
          path="/artist/raise-ticket"
          element={
            <ProtectedRoute>
              <RaiseTicket />
            </ProtectedRoute>
          }
        />
          <Route
          path="/faqs"
          element={
            <ProtectedRoute>
              <Faq/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/career"
          element={<Career />}
        />
         <Route
          path="/get-verified-on-spotify"
          element={
          <SpotifyForArtists/>
          }
        />
         <Route
          path="/distribute-music-on-apple-music"
          element={
          <DistributeAppleMusic/>
          }
        />
          <Route
          path="/refund-policy"
          element={
          <RefundPolicy/>
          }
        />
          <Route
          path="/get-music-on-jio-saavn"
          element={
          <GetMusicOnJioSaavn/>
          }
        />
         <Route
          path="/get-music-on-tik-tok"
          element={
          <TikTokForArtists/>
          }
        />
         <Route
          path="/get-music-on-deezer"
          element={
          <DeezerForArtists/>
          }
        />
          <Route
          path="/get-music-on-boomplay"
          element={
          <GetMusicOnBoomplay/>
          }
        />
         <Route
          path="/get-music-on-anghami"
          element={
          <AnghamiForArtists />
          }
        />
          <Route
          path="/get-music-on-amazon-music"
          element={
          <AmazonMusicForArtists />
          }
        />
        <Route
          path="/get-music-on-google-play-music"
          element={
          <GooglePlayMusicForArtists />
          }
        />
        <Route
          path="/get-music-on-7digital"
          element={
          <GetMusicOn7Digital />
          }
        />
        <Route
          path="/get-music-on-awa"
          element={
          <GetMusicOnAWA />
          }
        />      
         <Route
          path="/get-music-on-beatport"
          element={
          <GetMusicOnBeatport />
          }
        />
          <Route
          path="/get-music-on-beatsource"
          element={
          <GetMusicOnBeatsource />
          }
        />
         <Route
          path="/get-music-on-tidal"
          element={
          <GetMusicOnTidal />
          }
        />        
         <Route
          path="/get-music-on-facebook"
          element={
          <GetMusicOnFacebook />
          }
        />         
        <Route
          path="/get-music-on-youtube"
          element={
          <GetMusicOnYoutube />
          }
        />        
        <Route
          path="/get-music-on-bleep"
          element={
          <GetMusicOnBeep />
          }
        />
         <Route
          path="/get-music-on-bmat"
          element={
          <GetMusicOnBMAT />
          }
        />
          <Route
          path="/get-music-on-gracenote"
          element={
          <GetMusicOnGracenote />
          }
        />
          <Route
          path="/get-music-on-fizy"
          element={
          <GetMusicOnFizy />
          }
        />
         <Route
          path="/get-music-on-tencent"
          element={
          <GetMusicOnTencent />
          }
        />        
         <Route
          path="/get-music-on-hungama"
          element={
          <GetMusicOnHungama />
          }
        />        
         <Route
          path="/get-music-on-vevo"
          element={
          <GetMusicOnVevo />
          }
        />        
         <Route
          path="/get-music-on-sound-cloud"
          element={
          <GetMusicOnSoundCloud />
          }
        />        
         <Route
          path="/get-music-on-huawei"
          element={
          <GetMusicOnHuawei/>
          }
        />
          <Route
          path="/get-music-on-lenovo"
          element={
          <GetMusicOnLenovo/>
          }
        />         
         <Route
          path="/get-music-on-gionee"
          element={
          <GetMusicOnGionee/>
          }
        />
         <Route
          path="/get-music-on-raaga"
          element={
          <GetMusicOnRaaga/>
          }
        />      
          <Route
          path="/get-music-on-youtube-music"
          element={
          <GetMusicOnYouTubeMusic/>
          }
        />        
          <Route
          path="/get-music-on-onkyo"
          element={
          <GetMusicOnOnkyo/>
          }
        />          
        <Route
          path="/get-music-on-kkbox"
          element={
          <GetMusicOnKKBOX/>
          }
        />        
        <Route
          path="/get-music-on-line-music"
          element={
          <GetMusicOnLineMusic/>
          }
        />       
         <Route
          path="/get-music-on-yandex"
          element={
          <GetMusicOnYandex/>
          }
        />
         <Route
          path="/content-policy"
          element={
          <ContentPolicy/>
          }
        />
         <Route
          path="/cookie-policy"
          element={
          <CookiePolicy/>
          }
        />
         <Route
          path="/artist-agreement"
          element={
          <ArtistAgreement/>
          }
        />
         <Route
          path="/label-agreement"
          element={
          <LabelAgreement/>
          }
        />
      </Routes>
      <ScrollToTopButton />
      <Footerr />
      <ContactFloat/>
    </div>
  );
}

export default App;
